import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'photo-dialog',
  standalone: true,
  templateUrl: './photo-dialog.component.html',
  styleUrls: ['./photo-dialog.component.scss'],
  imports: [
    MatIcon
  ]
})
export class PhotoDialogComponent {
  constructor(
      private dialogRef: MatDialogRef<PhotoDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  close() {
    this.dialogRef.close();
  }
}
